<template>
    <b-row>

        <div class="col pt-2">

            <!--  Page  -->
            <div v-if="user_permissions.includes('read-template-messages')" class="bg-white rounded py-2 shadow-widget border">

                <!-- Page header -->
                <div class="px-3">

                    <div class="d-flex">

                        <div>
                            <h4>{{ $t('macros.template_messages') }}</h4>
                            <div class="text-muted template-header-info"> {{ $t('macros.template_messages_desc') }}</div>
                        </div>

                        <div class="ml-auto align-self-center d-flex">
                          <div v-b-tooltip.hover.right="{
                               title:!user_permissions.includes('create-template-messages')? $t('permission.permission_denied', { permission: 'create-template-messages' }) : '',customClass: 'tooltip-dark' }"
                               style="display: inline-block">
                            <b-button :variant="'info'" :to="{
                                name: 'template_message_setup'
                            }" :class="['btn-sm mr-2 px-3',{ 'cursor-not-allowed': !user_permissions.includes('create-template-messages') }]"
                                      :disabled="!user_permissions.includes('create-template-messages')">
                              <font-awesome-icon :icon="'plus'" />
                              {{ $t('default.add') }}
                            </b-button>
                          </div>

                            <b-button :variant="'outline-info'" @click="refreshTemplateMessages({whatsapp_accounts: whatsapp_accounts})"
                                class="btn-sm">
                                <font-awesome-icon :icon="'sync'" />
                                {{ $t('default.refresh') }}
                            </b-button>

                        </div>

                    </div>

                </div>

                <hr>

              <!-- Tabs -->
              <b-tabs v-model="activeTab" @input="handleTabChange">
                <!-- Template Messages Tab -->
                <b-tab :title="$t('macros.template_messages')" active>
                  <div class="px-2">
                    <b-row class="my-2">
                      <b-col>
                        <b-pagination v-model="currentPage"
                                      :total-rows="totalRows"
                                      :per-page="perPage"
                                      hide-goto-end-buttons
                                      size="sm" class="my-0"></b-pagination>
                      </b-col>
                      <b-col md="4" class="my-2 ml-auto">
                        <b-input-group>
                          <b-form-input v-model="filter" :placeholder="$t('simple.type_to_search')" />
                          <b-input-group-append>
                            <b-btn :disabled="!filter" @click="filter = ''">{{ $t('simple.clear') }}</b-btn>
                          </b-input-group-append>
                        </b-input-group>
                      </b-col>
                    </b-row>

                    <b-table stacked="lg" responsive bordered hover
                             :current-page="currentPage"
                             :per-page="perPage"
                             :filter="filter"
                             :items="template_messages"
                             :fields="window_width >= 1200 ? template_message_fields : template_message_fields_collapsed"
                             @filtered="onFiltered">

                      <!-- Actions -->
                      <template slot="cell(actions)" slot-scope="cell">

                        <b-button size="sm" @click="cell.toggleDetails()" v-if="window_width < 1200">
                          {{ cell.detailsShowing ? 'Hide' : 'Show' }} Details
                        </b-button>

                        <b-dropdown right :text="$t('simple.actions')" size="sm"
                                    v-if="cell.item.can_update || cell.item.can_delete">

                          <b-dropdown-item v-if="cell.item.can_update" @click="templateMessageEdit(cell.item)" :class="!user_permissions.includes('update-template-messages') ? 'cursor-not-allowed' : ''"
                                           v-b-tooltip.hover.right="{ title: !user_permissions.includes('update-template-messages') ? $t('permission.permission_denied', { permission: 'update-template-messages' }) : '', customClass: 'tooltip-dark' }"
                                           :disabled="!user_permissions.includes('update-template-messages')">{{
                              $t('simple.edit') }}</b-dropdown-item>

                          <b-dropdown-item v-if="cell.item.can_delete"
                                           @click="deleteTemplate(cell.item.account_id, cell.item.id)" :class="!user_permissions.includes('delete-template-messages') ? 'cursor-not-allowed' : ''"
                                           v-b-tooltip.hover.right="{ title: !user_permissions.includes('delete-template-messages') ? $t('permission.permission_denied', { permission: 'delete-template-messages' }) : '', customClass: 'tooltip-dark' }"
                                           :disabled="!user_permissions.includes('delete-template-messages')">{{
                              $t('simple.delete') }}</b-dropdown-item>

                        </b-dropdown>

                      </template>

                      <template #row-details="row">
                        <b-table small stacked="md" class="d-xl-none" responsive bordered hover :items="[row.item]"
                                 :fields="template_message_fields_not_collapsed">
                          <!-- Created at -->
                          <template slot="cell(created_at)" slot-scope="cell">

                            {{ $moment($moment.utc(cell.item.created_at)).local().format('YYYY-MM-DD HH:mm') }}

                          </template>

                          <!-- Updated at -->
                          <template slot="cell(updated_at)" slot-scope="cell">

                            {{ $moment($moment.utc(cell.item.updated_at)).local().format('YYYY-MM-DD HH:mm') }}

                          </template>

                        </b-table>
                      </template>

                      <!-- Created at -->
                      <template slot="cell(created_at)" slot-scope="cell">

                        {{ $moment($moment.utc(cell.item.created_at)).local().format('YYYY-MM-DD HH:mm') }}

                      </template>
                      <!-- Updated at -->
                      <template slot="cell(updated_at)" slot-scope="cell">

                        {{ $moment($moment.utc(cell.item.updated_at)).local().format('YYYY-MM-DD HH:mm') }}

                      </template>

                      <!-- Account -->
                      <template slot="cell(account_name)" slot-scope="cell">
                                <span v-b-tooltip.hover :title="cell.item.account_username">{{ cell.item.account_name }}
                                    <font-awesome-icon :icon="'question-circle'" size="sm" /></span>
                      </template>

                      <template slot="cell(content)" slot-scope="cell">
                        <span class="font-weight-bold" v-if="cell.item.header">{{ cell.item.header }} | </span>{{ cell.item.content }}
                      </template>

                      <!-- Buttons  -->
                      <template slot="cell(buttons)" slot-scope="cell">
                                <span
                                    class="d-inline-block text-truncate"
                                    :style="{ maxWidth: '150px' }"
                                    v-b-tooltip.hover
                                    :title="template_button_normalize(cell.item.buttons)">
                                    {{ template_button_normalize(cell.item.buttons) }}
                                </span>
                      </template>

                      <!-- Status -->
                      <template slot="cell(status)" slot-scope="cell">
                                <span v-b-tooltip.hover :title="cell.item.reject_reason ? cell.item.reject_reason : ''"
                                      :class="{ 'text-danger': cell.item.status === 'rejected', 'text-warning': cell.item.status === 'pending', 'text-success': cell.item.status === 'approved' }">
                                    {{ cell.item.status.toUpperCase() }}
                                    <font-awesome-icon v-if="cell.item.reject_reason" :icon="'exclamation-circle'"
                                                       size="sm" /> </span>

                      </template>


                    </b-table>

                    <v-wait for="template_messages">

                      <loading slot="waiting" />

                    </v-wait>

                  </div>

                </b-tab>
                <b-tab :title="$t('macros.removed_template_messages')">
                  <div class="px-2">
                    <b-row class="my-2">
                      <b-col>
                        <b-pagination v-model="currentPage"
                                      :total-rows="totalRows"
                                      :per-page="perPage"
                                      hide-goto-end-buttons
                                      size="sm" class="my-0"></b-pagination>
                      </b-col>
                      <b-col md="4" class="my-2 ml-auto">
                        <b-input-group>
                          <b-form-input v-model="filter" :placeholder="$t('simple.type_to_search')" />
                          <b-input-group-append>
                            <b-btn :disabled="!filter" @click="filter = ''">{{ $t('simple.clear') }}</b-btn>
                          </b-input-group-append>
                        </b-input-group>
                      </b-col>
                    </b-row>

                    <b-table stacked="lg" responsive bordered hover
                             :current-page="currentPage"
                             :per-page="perPage"
                             :filter="filter"
                             :items="template_messages"
                             :fields="deleted_template_fields"
                             @filtered="onFiltered">

                      <!-- Actions -->
                      <template slot="cell(actions)" slot-scope="cell">

                        <b-button size="sm" @click="cell.toggleDetails()" v-if="window_width < 1200">
                          {{ cell.detailsShowing ? 'Hide' : 'Show' }} Details
                        </b-button>

                      </template>

                      <template #row-details="row">
                        <b-table small stacked="md" class="d-xl-none" responsive bordered hover :items="[row.item]"
                                 :fields="deleted_template_fields">
                          <!-- Created at -->
                          <template slot="cell(created_at)" slot-scope="cell">

                            {{ $moment($moment.utc(cell.item.created_at)).local().format('YYYY-MM-DD HH:mm') }}

                          </template>

                          <!-- Updated at -->
                          <template slot="cell(updated_at)" slot-scope="cell">

                            {{ $moment($moment.utc(cell.item.updated_at)).local().format('YYYY-MM-DD HH:mm') }}

                          </template>
                          <template slot="cell(buttons)" slot-scope="cell">
                                <span
                                    class="d-inline-block text-truncate"
                                    :style="{ maxWidth: '150px' }"
                                    v-b-tooltip.hover
                                    :title="template_button_normalize(cell.item.buttons)">
                                    {{ template_button_normalize(cell.item.buttons) }}
                                </span>
                          </template>

                        </b-table>
                      </template>

                      <!-- Created at -->
                      <template slot="cell(created_at)" slot-scope="cell">

                        {{ $moment($moment.utc(cell.item.created_at)).local().format('YYYY-MM-DD HH:mm') }}

                      </template>
                      <!-- Updated at -->
                      <template slot="cell(updated_at)" slot-scope="cell">

                        {{ $moment($moment.utc(cell.item.updated_at)).local().format('YYYY-MM-DD HH:mm') }}

                      </template>

                      <template slot="cell(deleted_at)" slot-scope="cell">

                        {{ $moment($moment.utc(cell.item.deleted_at)).local().format('YYYY-MM-DD HH:mm') }}

                      </template>
                      <!-- Status -->
                      <template slot="cell(status)" slot-scope="cell">
                                <span v-b-tooltip.hover :title="cell.item.reject_reason ? cell.item.reject_reason : ''"
                                      :class="{ 'text-danger': cell.item.status === 'rejected', 'text-warning': cell.item.status === 'pending', 'text-success': cell.item.status === 'approved' }">
                                    {{ cell.item.status.toUpperCase() }}
                                    <font-awesome-icon v-if="cell.item.reject_reason" :icon="'exclamation-circle'"
                                                       size="sm" /> </span>

                      </template>

                      <!-- Account -->
                      <template slot="cell(account_name)" slot-scope="cell">
                                <span v-b-tooltip.hover :title="cell.item.account_username">{{ cell.item.account_name }}
                                    <font-awesome-icon :icon="'question-circle'" size="sm" /></span>
                      </template>

                      <template slot="cell(content)" slot-scope="cell">
                        <span class="font-weight-bold" v-if="cell.item.header">{{ cell.item.header }} | </span>{{ cell.item.content }}
                      </template>
                      <template slot="cell(buttons)" slot-scope="cell">
                                <span
                                    class="d-inline-block text-truncate"
                                    :style="{ maxWidth: '150px' }"
                                    v-b-tooltip.hover
                                    :title="template_button_normalize(cell.item.buttons)">
                                    {{ template_button_normalize(cell.item.buttons) }}
                                </span>
                      </template>

                    </b-table>

                    <v-wait for="template_messages">

                      <loading slot="waiting" />

                    </v-wait>

                  </div>
                </b-tab>
              </b-tabs>


                <!-- Page content -->


            </div>
            <div class="alert alert-danger text-center mt-5" style="max-width: 50%; margin: 0 auto;" v-if="permissionsReady && !user_permissions.includes('read-template-messages')">
              {{ $t('permission.permission_denied',{ permission: 'read-template-messages'}) }}
            </div>
        </div>

    </b-row>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import TemplateMessageEdit from '../Modal/TemplateMessageEdit.vue'
import { create } from 'vue-modal-dialogs'




export default {
    metaInfo: function () {
        return {
            title: 'Templates Messages',
        }
    },
    mounted: function () {
      console.log('listening to template event')
      if (this.user){
        console.log('listening to template event with ',this.user)
        Echo.private('template.' + this.user.company_id)
            .listen('TemplateEvent', (e) => {
              console.log('event listen', e);
              this.updateTemplateMessageStatus({template_id: e.template_id, status: e.status});
            });
      }
    },
    async created() {
        await this.fetchAccounts()
        await this.fetchTemplateMessages({whatsapp_accounts:this.whatsapp_accounts})

        this.totalRows = this.template_messages.length

        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        })

    },

    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },

    data() {
        return {
          activeTab: 0,
          showDeletedTemplates:false,
            window_width: window.innerWidth,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            filter:null,
            template_message_fields: [
                { key: 'account_name', label: this.$t('simple.account'), sortable: true },
                { key: 'name', label: this.$t('macros.template_name'), sortable: true },
                { key: 'content', label: this.$t('simple.content'), sortable: true, thStyle: { width: "20%" }, },
                { key: 'buttons', label: this.$t('macros.buttons') },
                { key: 'category', label: this.$t('default.category'), sortable: true },
                { key: 'template_type', label: this.$t('macros.template_type'), sortable: true },
                { key: 'status', label: this.$t('simple.status'), sortable: true },
                { key: 'created_at', label: this.$t('simple.created'), sortable: true },
                { key: 'updated_at', label: this.$t('simple.updated'), sortable: true },
                { key: 'actions', label: this.$t('simple.actions') },
            ],

            template_message_fields_collapsed: [
                { key: 'account_name', label: this.$t('simple.account'), sortable: true },
                { key: 'name', label: this.$t('macros.template_name'), sortable: true },
                { key: 'content', label: this.$t('simple.content'), sortable: true, thStyle: { width: "20%" }, },
                { key: 'buttons', label: this.$t('macros.buttons'), thStyle: { 'max-width': "10%" }, },
                { key: 'status', label: this.$t('simple.status'), sortable: true },
                { key: 'actions', label: this.$t('simple.actions') },
            ],

            template_message_fields_not_collapsed: [
                { key: 'category', label: this.$t('default.category'), sortable: true },
                { key: 'template_type', label: this.$t('macros.template_type'), sortable: true },
                { key: 'created_at', label: this.$t('simple.created'), sortable: true },
                { key: 'updated_at', label: this.$t('simple.updated'), sortable: true },
            ],
          deleted_template_fields: [
            { key: 'account_name', label: this.$t('simple.account'), sortable: true },
            { key: 'name', label: this.$t('macros.template_name'), sortable: true },
            { key: 'content', label: this.$t('simple.content'), sortable: true, thStyle: { width: "20%" }, },
            { key: 'buttons', label: this.$t('macros.buttons') },
            { key: 'category', label: this.$t('default.category'), sortable: true },
            { key: 'template_type', label: this.$t('macros.template_type'), sortable: true },
            { key: 'status', label: this.$t('simple.status'), sortable: true },
            { key: 'created_at', label: this.$t('simple.created'), sortable: true },
            { key: 'updated_at', label: this.$t('simple.updated'), sortable: true },
            { key: 'deleted_at', label: this.$t('simple.deleted_at'), sortable: true }, // New column
          ],

        }
    },

    methods: {
        ...mapActions('Templates', [
            'fetchTemplateMessages',
            'deleteTemplateMessage',
            'refreshTemplateMessages',
            'fetchRemovedTemplateMessages',
            'updateCurrentPage',
            'updateFilterTemplateMessages',
            'updateFilterRemovedTemplateMessages',
            'updateTemplateMessageStatus'
        ]),
        ...mapActions('Accounts', [
            'fetchAccounts',
        ]),

async fetchRemovedTemplates(){
  this.showDeletedTemplates = true;
  await this.fetchRemovedTemplateMessages({whatsapp_accounts:this.whatsapp_accounts})

  this.totalRows = this.template_messages.length
},
        async templateMessageEdit(template) {
          if (template.buttons && Array.isArray(template.buttons)) {
            template.buttons = template.buttons.map(button => {
              if (button.type === 'URL') {
                button.variable = button.url.includes('{{1}}') ? 'true' : 'false';
                button.url = button.url.replace('{{1}}', '');
              }
              return button;
            });
          }
            // Show account edit modal
            const template_message_edit = create(TemplateMessageEdit, 'template');

            await template_message_edit(template)
        },

        async deleteTemplate(account_id, template_id) {
            await this.deleteTemplateMessage({ account_id: account_id, template_id: template_id })
                .then(() => {
                    this.refreshTemplateMessages({whatsapp_accounts: this.whatsapp_accounts})
                })
        },
      async handleTabChange(tabIndex) {
        this.activeTab = tabIndex;
        if (tabIndex === 0) {
          // Fetch Template Messages
          await this.fetchTemplateMessages({ whatsapp_accounts: this.whatsapp_accounts });
        } else if (tabIndex === 1) {
          // Fetch Removed Template Messages
          await this.fetchRemovedTemplateMessages({ whatsapp_accounts: this.whatsapp_accounts });
        }
        this.totalRows = this.template_messages.length;
      },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },

        onResize() {
            this.window_width = window.innerWidth;
        },

      template_button_normalize(buttons) {
        if (Array.isArray(buttons)) { // Ensure buttons is an array
          return buttons.flatMap(button => {
            if (button.type === 'QUICK_REPLY') {
              return `${button.type}(${button.text}) `;
            } else if (button.type === 'URL') {
              return `${button.type}(${button.url}) `;
            }
            return `${button.type}(${button.phone_number}) `;
          });
        }
        return '-';
      }
    },

    computed: {
        ...mapGetters({
            accounts: 'Accounts/getAccounts',
            template_messages: 'Templates/getTemplateMessages',
            // total: 'Templates/getTotal',
            // getCurrent: 'Templates/getCurrent',
            getFilterTemplateMessages: 'Templates/getFilterTemplateMessages',
            user_permissions: 'User/getUserPermissions',
            // perpage: 'Templates/getPerPage',
            user: 'User/getUser'
        }),

        current: {
            get() {
                return this.getCurrent
            },
            set(value) {
                this.updateCurrentPage(value)
                this.fetchTemplateMessages({whatsapp_accounts:this.whatsapp_accounts, page:value})
            }
        },

        whatsapp_accounts() {
            return this.accounts.filter(account => account.integration_id === 'whatsapp')
        },
      permissionsReady() {
        return Array.isArray(this.user_permissions) && this.user_permissions.length > 0;
      }
      // filter:{
      //   get(){
      //     return this.getFilterTemplateMessages
      //   },
      //   set(newFilter) {
      //     if (this.getFilterTemplateMessages !== newFilter) {
      //       this.updateFilterTemplateMessages(newFilter);
      //       this.fetchTemplateMessages({ whatsapp_accounts: this.whatsapp_accounts, page: 1, filter: newFilter });
      //     }
      //   }
      // },
      // filter_removed:{
      //   get(newFilter){
      //     return this.getFilterRemovedTemplateMessages
      //   },
      //   set(newFilter) {
      //     this.updateFilterRemovedTemplateMessages(newFilter);
      //     this.fetchRemovedTemplateMessages({ whatsapp_accounts: this.whatsapp_accounts,page:1,filter:newFilter});
      //   }
      // }
    },
}
</script>